import { Button, Disclaimer, Icon, Spacer } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { ISO8601Date, NetzwerkDto, Referenz, Tier } from 'types';
import { copyQuery, scrollToAnchor } from 'utils';
import { useTranslation } from 'utils/hooks';

import Beteiligungen from './Beteiligungen';
import css from './Beteiligungen.module.scss';


interface BeteiligungenContentRowProps
{
  title: string;
  netzwerk: Record<string, NetzwerkDto>;
  origin: Referenz;
  inconsistent: boolean;
  allowExtendedView: boolean;
  tier: Tier;
}

const BeteiligungenContentRow: React.FC<BeteiligungenContentRowProps> = ({ netzwerk, origin, title, inconsistent, allowExtendedView, tier }) =>
{
  const { t } = useTranslation();
  const router = useRouter();

  const sortedDates = Object.keys(netzwerk).sort((a, b) => b.localeCompare(a));
  const [selectedDate, setSelectedDate] = useState<ISO8601Date>(sortedDates[0]);

  const setNewDate = (date: ISO8601Date) => 
  {
    if (tier === 'Plus')
    {
      setSelectedDate(date);
    }
    else if (date === sortedDates[0])
    {
      setSelectedDate(date);
    }
    else 
    {
      document.getElementById('plus-inhalte')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  function renderDateSelection()
  {
    return (
      <div style={{ margin: '0.5rem 0' }}>
        {tier !== 'Free' && (
          <>
          <select
            onChange={(event) => setNewDate(event.target.value)}
            value={selectedDate}
          >
            {tier === 'Plus' ? sortedDates.map((date, index) => (
              <option key={date} value={date}>
                { index === 0 ? t('profiles:lastChange') : t('formats:date', { value: date }) }
              </option>
            )) : <>
              <option value={sortedDates[0]}>
                {t('profiles:lastChange')}
              </option>
              <optgroup label={'Plus Inhalte'}>
                {sortedDates.slice(1).map((date) => (
                  <option key={date} value={date}>
                    {t('formats:date', { value: date })}
                  </option>
                ))}
              </optgroup>
            </>
            }
          </select>
            {allowExtendedView && <div className={css.netzwerkFullScreenWrapper} style={{ margin: '0.5rem 0' }}>
            <Button
                  variant="secondary"
                  onClick={tier === 'Plus' ? () => router.push({
                    pathname: router.pathname + '/netzwerk',
                    query: copyQuery(router.query, ['id', 'token']),
                  }) : () => scrollToAnchor('plus-inhalte', -100)}
              >
                  <Icon name={tier === 'Plus' ? 'maximize' : 'lock'}/>
                {t('profiles:actions.openNetzwerkFullscreen')}
                  <div className={css.beta}> {t('profiles:beta')}</div>
              </Button>
          </div>}
          </>
        )}
        {tier === 'Free' && (
          <Button
            variant="secondary"
            onClick={() => scrollToAnchor('plus-inhalte', -100)}
          >
            <Icon name="lock" />
            {t('profiles:actions.openFullscreen')}
          </Button>
        )}
      </div>
    );
  }

  return (
    <ContentRow
      id="netzwerk"
      title={title}
      actionRenderer={renderDateSelection}
    >
      <div className={css.container}>
        <h4>{selectedDate === sortedDates[0] ? t('profiles:currentSince', { date: selectedDate }) : t('formats:date', { value: selectedDate }) }</h4>
        <Beteiligungen
          origin={origin}
          netzwerk={netzwerk[selectedDate]}
        />
      </div>
      {inconsistent && 
        <>
          <Spacer height={2} />
          <Disclaimer text={t('profiles:inconsistencyDisclaimer')} />
          <Spacer height={2} />
      </>}
    </ContentRow>
  );
};

export default BeteiligungenContentRow;
